import Vue from 'vue'
import Vuex from 'vuex'
import creative from './creative'
import report from './report'
import modal from './modal'
import user from './user'
import widget from './widget'
import pop_up from './pop_up'
import ui_element from './ui_element'
import heatmap from './heatmap'
import area_pop_up from './area_pop_up'
import scenario_popup from './scenario_popup'
import overlay from './overlay'
import tag from './tag'
import youtube from './youtube'
import custom_plan from './custom_plan'
import heatmap_multi from './heatmap_multi'

Vue.use(Vuex)

const debug = process.env.NODE_ENV == 'development'

export default new Vuex.Store({
    modules: {
        creative,
        report,
        modal,
        user,
        widget,
        pop_up,
        ui_element,
        heatmap,
        heatmap_multi,
        area_pop_up,
        scenario_popup,
        overlay,
        tag,
        youtube,
        custom_plan
    },
    strict: debug
})
